import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/downcast
 */
import TableWalker from "./../tablewalker";
import { toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils';
import { toTableWidget } from "../utils";
/**
 * Model table element to view table element conversion helper.
 *
 * This conversion helper creates the whole table element with child elements.
 *
 * @param {Object} options
 * @param {Boolean} options.asWidget If set to `true`, the downcast conversion will produce a widget.
 * @returns {Function} Conversion helper.
 */

export function downcastInsertTable() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatcher) {
    return dispatcher.on('insert:table', function (evt, data, conversionApi) {
      var table = data.item;

      if (!conversionApi.consumable.consume(table, 'insert')) {
        return;
      } // Consume attributes if present to not fire attribute change downcast


      conversionApi.consumable.consume(table, 'attribute:headingRows:table');
      conversionApi.consumable.consume(table, 'attribute:headingColumns:table');
      var asWidget = options && options.asWidget;
      var figureElement = conversionApi.writer.createContainerElement('figure', {
        class: 'table'
      });
      var tableElement = conversionApi.writer.createContainerElement('table');
      conversionApi.writer.insert(conversionApi.writer.createPositionAt(figureElement, 0), tableElement);
      var tableWidget;

      if (asWidget) {
        tableWidget = toTableWidget(figureElement, conversionApi.writer);
      }

      var tableWalker = new TableWalker(table);
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // Cache for created table rows.

      var viewRows = new Map();

      var _iterator = _createForOfIteratorHelper(tableWalker),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tableWalkerValue = _step.value;
          var row = tableWalkerValue.row,
              cell = tableWalkerValue.cell;
          var tableSection = getOrCreateTableSection(getSectionName(row, tableAttributes), tableElement, conversionApi);
          var tableRow = table.getChild(row);
          var trElement = viewRows.get(row) || createTr(tableRow, row, tableSection, conversionApi);
          viewRows.set(row, trElement); // Consume table cell - it will be always consumed as we convert whole table at once.

          conversionApi.consumable.consume(cell, 'insert');
          var insertPosition = conversionApi.writer.createPositionAt(trElement, 'end');
          createViewTableCellElement(tableWalkerValue, tableAttributes, insertPosition, conversionApi, options);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var viewPosition = conversionApi.mapper.toViewPosition(data.range.start);
      conversionApi.mapper.bindElements(table, asWidget ? tableWidget : figureElement);
      conversionApi.writer.insert(viewPosition, asWidget ? tableWidget : figureElement);
    });
  };
}
/**
 * Model row element to view `<tr>` element conversion helper.
 *
 * This conversion helper creates the whole `<tr>` element with child elements.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastInsertRow() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatcher) {
    return dispatcher.on('insert:tableRow', function (evt, data, conversionApi) {
      var tableRow = data.item;

      if (!conversionApi.consumable.consume(tableRow, 'insert')) {
        return;
      }

      var table = tableRow.parent;
      var figureElement = conversionApi.mapper.toViewElement(table);
      var tableElement = getViewTable(figureElement);
      var row = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        startRow: row,
        endRow: row
      });
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // Cache for created table rows.

      var viewRows = new Map();

      var _iterator2 = _createForOfIteratorHelper(tableWalker),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tableWalkerValue = _step2.value;
          var tableSection = getOrCreateTableSection(getSectionName(row, tableAttributes), tableElement, conversionApi);
          var trElement = viewRows.get(row) || createTr(tableRow, row, tableSection, conversionApi);
          viewRows.set(row, trElement); // Consume table cell - it will be always consumed as we convert whole row at once.

          conversionApi.consumable.consume(tableWalkerValue.cell, 'insert');
          var insertPosition = conversionApi.writer.createPositionAt(trElement, 'end');
          createViewTableCellElement(tableWalkerValue, tableAttributes, insertPosition, conversionApi, options);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
  };
}
/**
 * Model table cell element to view `<td>` or `<th>` element conversion helper.
 *
 * This conversion helper will create proper `<th>` elements for table cells that are in the heading section (heading row or column)
 * and `<td>` otherwise.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastInsertCell() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatcher) {
    return dispatcher.on('insert:tableCell', function (evt, data, conversionApi) {
      var tableCell = data.item;

      if (!conversionApi.consumable.consume(tableCell, 'insert')) {
        return;
      }

      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowIndex = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        startRow: rowIndex,
        endRow: rowIndex
      });
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // We need to iterate over a table in order to get proper row & column values from a walker

      var _iterator3 = _createForOfIteratorHelper(tableWalker),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tableWalkerValue = _step3.value;

          if (tableWalkerValue.cell === tableCell) {
            var trElement = conversionApi.mapper.toViewElement(tableRow);
            var insertPosition = conversionApi.writer.createPositionAt(trElement, tableRow.getChildIndex(tableCell));
            createViewTableCellElement(tableWalkerValue, tableAttributes, insertPosition, conversionApi, options); // No need to iterate further.

            return;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
  };
}
/**
 * Conversion helper that acts on heading rows table attribute change.
 *
 * This converter will:
 *
 * * Rename `<td>` to `<th>` elements or vice versa depending on headings.
 * * Create `<thead>` or `<tbody>` elements if needed.
 * * Remove empty `<thead>` or `<tbody>` if needed.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastTableHeadingRowsChange() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var asWidget = !!options.asWidget;
  return function (dispatcher) {
    return dispatcher.on('attribute:headingRows:table', function (evt, data, conversionApi) {
      var table = data.item;

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var figureElement = conversionApi.mapper.toViewElement(table);
      var viewTable = getViewTable(figureElement);
      var oldRows = data.attributeOldValue;
      var newRows = data.attributeNewValue; // The head section has grown so move rows from <tbody> to <thead>.

      if (newRows > oldRows) {
        // Filter out only those rows that are in wrong section.
        var rowsToMove = Array.from(table.getChildren()).filter(function (_ref) {
          var index = _ref.index;
          return isBetween(index, oldRows - 1, newRows);
        });
        var viewTableHead = getOrCreateTableSection('thead', viewTable, conversionApi);
        moveViewRowsToTableSection(rowsToMove, viewTableHead, conversionApi, 'end'); // Rename all table cells from moved rows to 'th' as they lands in <thead>.

        var _iterator4 = _createForOfIteratorHelper(rowsToMove),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var tableRow = _step4.value;

            var _iterator5 = _createForOfIteratorHelper(tableRow.getChildren()),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var tableCell = _step5.value;
                renameViewTableCell(tableCell, 'th', conversionApi, asWidget);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          } // Cleanup: this will remove any empty section from the view which may happen when moving all rows from a table section.

        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        removeTableSectionIfEmpty('tbody', viewTable, conversionApi);
      } // The head section has shrunk so move rows from <thead> to <tbody>.
      else {
          // Filter out only those rows that are in wrong section.
          var _rowsToMove = Array.from(table.getChildren()).filter(function (_ref2) {
            var index = _ref2.index;
            return isBetween(index, newRows - 1, oldRows);
          }).reverse(); // The rows will be moved from <thead> to <tbody> in reverse order at the beginning of a <tbody>.


          var viewTableBody = getOrCreateTableSection('tbody', viewTable, conversionApi);
          moveViewRowsToTableSection(_rowsToMove, viewTableBody, conversionApi, 0); // Check if cells moved from <thead> to <tbody> requires renaming to <td> as this depends on current heading columns attribute.

          var tableWalker = new TableWalker(table, {
            startRow: newRows ? newRows - 1 : newRows,
            endRow: oldRows - 1
          });
          var tableAttributes = {
            headingRows: table.getAttribute('headingRows') || 0,
            headingColumns: table.getAttribute('headingColumns') || 0
          };

          var _iterator6 = _createForOfIteratorHelper(tableWalker),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var tableWalkerValue = _step6.value;
              renameViewTableCellIfRequired(tableWalkerValue, tableAttributes, conversionApi, asWidget);
            } // Cleanup: this will remove any empty section from the view which may happen when moving all rows from a table section.

          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          removeTableSectionIfEmpty('thead', viewTable, conversionApi);
        }

      function isBetween(index, lower, upper) {
        return index > lower && index < upper;
      }
    });
  };
}
/**
 * Conversion helper that acts on heading columns table attribute change.
 *
 * Depending on changed attributes this converter will rename `<td` to `<th>` elements or vice versa depending of the cell column index.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastTableHeadingColumnsChange() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var asWidget = !!options.asWidget;
  return function (dispatcher) {
    return dispatcher.on('attribute:headingColumns:table', function (evt, data, conversionApi) {
      var table = data.item;

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      };
      var oldColumns = data.attributeOldValue;
      var newColumns = data.attributeNewValue;
      var lastColumnToCheck = (oldColumns > newColumns ? oldColumns : newColumns) - 1;

      var _iterator7 = _createForOfIteratorHelper(new TableWalker(table)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var tableWalkerValue = _step7.value;

          // Skip cells that were not in heading section before and after the change.
          if (tableWalkerValue.column > lastColumnToCheck) {
            continue;
          }

          renameViewTableCellIfRequired(tableWalkerValue, tableAttributes, conversionApi, asWidget);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    });
  };
}
/**
 * Conversion helper that acts on a removed row.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastRemoveRow() {
  return function (dispatcher) {
    return dispatcher.on('remove:tableRow', function (evt, data, conversionApi) {
      // Prevent default remove converter.
      evt.stop();
      var viewWriter = conversionApi.writer;
      var mapper = conversionApi.mapper;
      var viewStart = mapper.toViewPosition(data.position).getLastMatchingPosition(function (value) {
        return !value.item.is('tr');
      });
      var viewItem = viewStart.nodeAfter;
      var tableSection = viewItem.parent; // Remove associated <tr> from the view.

      var removeRange = viewWriter.createRangeOn(viewItem);
      var removed = viewWriter.remove(removeRange);

      var _iterator8 = _createForOfIteratorHelper(viewWriter.createRangeIn(removed).getItems()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var child = _step8.value;
          mapper.unbindViewElement(child);
        } // Check if table section has any children left - if not remove it from the view.

      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      if (!tableSection.childCount) {
        // No need to unbind anything as table section is not represented in the model.
        viewWriter.remove(viewWriter.createRangeOn(tableSection));
      }
    }, {
      priority: 'higher'
    });
  };
} // Renames an existing table cell in the view to a given element name.
//
// **Note** This method will not do anything if a view table cell was not yet converted.
//
// @param {module:engine/model/element~Element} tableCell
// @param {String} desiredCellElementName
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @param {Boolean} asWidget

function renameViewTableCell(tableCell, desiredCellElementName, conversionApi, asWidget) {
  var viewWriter = conversionApi.writer;
  var viewCell = conversionApi.mapper.toViewElement(tableCell); // View cell might be not yet converted - skip it as it will be properly created by cell converter later on.

  if (!viewCell) {
    return;
  }

  var renamedCell;

  if (asWidget) {
    var editable = viewWriter.createEditableElement(desiredCellElementName, viewCell.getAttributes());
    renamedCell = toWidgetEditable(editable, viewWriter);
    viewWriter.insert(viewWriter.createPositionAfter(viewCell), renamedCell);
    viewWriter.move(viewWriter.createRangeIn(viewCell), viewWriter.createPositionAt(renamedCell, 0));
    viewWriter.remove(viewWriter.createRangeOn(viewCell));
  } else {
    renamedCell = viewWriter.rename(desiredCellElementName, viewCell);
  }

  conversionApi.mapper.unbindViewElement(viewCell);
  conversionApi.mapper.bindElements(tableCell, renamedCell);
} // Renames a table cell element in the view according to its location in the table.
//
// @param {module:table/tablewalker~TableWalkerValue} tableWalkerValue
// @param {{headingColumns, headingRows}} tableAttributes
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @param {Boolean} asWidget


function renameViewTableCellIfRequired(tableWalkerValue, tableAttributes, conversionApi, asWidget) {
  var cell = tableWalkerValue.cell; // Check whether current columnIndex is overlapped by table cells from previous rows.

  var desiredCellElementName = getCellElementName(tableWalkerValue, tableAttributes);
  var viewCell = conversionApi.mapper.toViewElement(cell); // If in single change we're converting attribute changes and inserting cell the table cell might not be inserted into view
  // because of child conversion is done after parent.

  if (viewCell && viewCell.name !== desiredCellElementName) {
    renameViewTableCell(cell, desiredCellElementName, conversionApi, asWidget);
  }
} // Creates a table cell element in the view.
//
// @param {module:table/tablewalker~TableWalkerValue} tableWalkerValue
// @param {module:engine/view/position~Position} insertPosition
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function createViewTableCellElement(tableWalkerValue, tableAttributes, insertPosition, conversionApi, options) {
  var asWidget = options && options.asWidget;
  var cellElementName = getCellElementName(tableWalkerValue, tableAttributes);
  var cellElement = asWidget ? toWidgetEditable(conversionApi.writer.createEditableElement(cellElementName), conversionApi.writer) : conversionApi.writer.createContainerElement(cellElementName);
  var tableCell = tableWalkerValue.cell;
  var firstChild = tableCell.getChild(0);
  var isSingleParagraph = tableCell.childCount === 1 && firstChild.name === 'paragraph';
  conversionApi.writer.insert(insertPosition, cellElement);

  if (isSingleParagraph && !hasAnyAttribute(firstChild)) {
    var innerParagraph = tableCell.getChild(0);
    var paragraphInsertPosition = conversionApi.writer.createPositionAt(cellElement, 'end');
    conversionApi.consumable.consume(innerParagraph, 'insert');

    if (options.asWidget) {
      var fakeParagraph = conversionApi.writer.createContainerElement('span');
      conversionApi.mapper.bindElements(innerParagraph, fakeParagraph);
      conversionApi.writer.insert(paragraphInsertPosition, fakeParagraph);
      conversionApi.mapper.bindElements(tableCell, cellElement);
    } else {
      conversionApi.mapper.bindElements(tableCell, cellElement);
      conversionApi.mapper.bindElements(innerParagraph, cellElement);
    }
  } else {
    conversionApi.mapper.bindElements(tableCell, cellElement);
  }
} // Creates `<tr>` view element.
//
// @param {module:engine/view/element~Element} tableRow
// @param {Number} rowIndex
// @param {module:engine/view/element~Element} tableSection
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @returns {module:engine/view/element~Element}


function createTr(tableRow, rowIndex, tableSection, conversionApi) {
  // Will always consume since we're converting <tableRow> element from a parent <table>.
  conversionApi.consumable.consume(tableRow, 'insert');
  var trElement = conversionApi.writer.createContainerElement('tr');
  conversionApi.mapper.bindElements(tableRow, trElement);
  var headingRows = tableRow.parent.getAttribute('headingRows') || 0;
  var offset = headingRows > 0 && rowIndex >= headingRows ? rowIndex - headingRows : rowIndex;
  var position = conversionApi.writer.createPositionAt(tableSection, offset);
  conversionApi.writer.insert(position, trElement);
  return trElement;
} // Returns `th` for heading cells and `td` for other cells for the current table walker value.
//
// @param {module:table/tablewalker~TableWalkerValue} tableWalkerValue
// @param {{headingColumns, headingRows}} tableAttributes
// @returns {String}


function getCellElementName(tableWalkerValue, tableAttributes) {
  var row = tableWalkerValue.row,
      column = tableWalkerValue.column;
  var headingColumns = tableAttributes.headingColumns,
      headingRows = tableAttributes.headingRows; // Column heading are all tableCells in the first `columnHeading` rows.

  var isColumnHeading = headingRows && headingRows > row; // So a whole row gets <th> element.

  if (isColumnHeading) {
    return 'th';
  } // Row heading are tableCells which columnIndex is lower then headingColumns.


  var isRowHeading = headingColumns && headingColumns > column;
  return isRowHeading ? 'th' : 'td';
} // Returns the table section name for the current table walker value.
//
// @param {Number} row
// @param {{headingColumns, headingRows}} tableAttributes
// @returns {String}


function getSectionName(row, tableAttributes) {
  return row < tableAttributes.headingRows ? 'thead' : 'tbody';
} // Creates or returns an existing `<tbody>` or `<thead>` element witch caching.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} viewTable
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @param {Object} cachedTableSection An object that stores cached elements.
// @returns {module:engine/view/containerelement~ContainerElement}


function getOrCreateTableSection(sectionName, viewTable, conversionApi) {
  var viewTableSection = getExistingTableSectionElement(sectionName, viewTable);
  return viewTableSection ? viewTableSection : createTableSection(sectionName, viewTable, conversionApi);
} // Finds an existing `<tbody>` or `<thead>` element or returns undefined.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function getExistingTableSectionElement(sectionName, tableElement) {
  var _iterator9 = _createForOfIteratorHelper(tableElement.getChildren()),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var tableSection = _step9.value;

      if (tableSection.name == sectionName) {
        return tableSection;
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
} // Creates a table section at the end of the table.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @returns {module:engine/view/containerelement~ContainerElement}


function createTableSection(sectionName, tableElement, conversionApi) {
  var tableChildElement = conversionApi.writer.createContainerElement(sectionName);
  var insertPosition = conversionApi.writer.createPositionAt(tableElement, sectionName == 'tbody' ? 'end' : 0);
  conversionApi.writer.insert(insertPosition, tableChildElement);
  return tableChildElement;
} // Removes an existing `<tbody>` or `<thead>` element if it is empty.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function removeTableSectionIfEmpty(sectionName, tableElement, conversionApi) {
  var tableSection = getExistingTableSectionElement(sectionName, tableElement);

  if (tableSection && tableSection.childCount === 0) {
    conversionApi.writer.remove(conversionApi.writer.createRangeOn(tableSection));
  }
} // Moves view table rows associated with passed model rows to the provided table section element.
//
// **Note** This method will skip not converted table rows.
//
// @param {Array.<module:engine/model/element~Element>} rowsToMove
// @param {module:engine/view/element~Element} viewTableSection
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @param {Number|'end'|'before'|'after'} offset Offset or one of the flags.


function moveViewRowsToTableSection(rowsToMove, viewTableSection, conversionApi, offset) {
  var _iterator10 = _createForOfIteratorHelper(rowsToMove),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var tableRow = _step10.value;
      var viewTableRow = conversionApi.mapper.toViewElement(tableRow); // View table row might be not yet converted - skip it as it will be properly created by cell converter later on.

      if (viewTableRow) {
        conversionApi.writer.move(conversionApi.writer.createRangeOn(viewTableRow), conversionApi.writer.createPositionAt(viewTableSection, offset));
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
} // Properly finds '<table>' element inside `<figure>` widget.
//
// @param {module:engine/view/element~Element} viewFigure


function getViewTable(viewFigure) {
  var _iterator11 = _createForOfIteratorHelper(viewFigure.getChildren()),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var child = _step11.value;

      if (child.name === 'table') {
        return child;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
} // Checks if element has any attribute set.
//
// @param {module:engine/model/element~Element element
// @returns {Boolean}


function hasAnyAttribute(element) {
  return !!_toConsumableArray(element.getAttributeKeys()).length;
}